// extracted by mini-css-extract-plugin
module.exports = {"lazy":"styles_lazy___9s4S","mobile":"styles_mobile__ms_dA","desktop":"styles_desktop__FRYqc","caption":"styles_caption__cUWm8"};